;(function () {
  angular
    .module('contrast.application.dashboard')
    .controller('AppSettingsModalCtrl', AppSettingsModalCtrl)

  function AppSettingsModalCtrl(
    $scope,
    $routeParams,
    $uibModalInstance,
    application,
    isAssessLanguageSupported,
    logger,
    ApplicationFactory,
    UserService,
    ErrorService,
    ApplicationService,
    APP_IMPORTANCE_RANKING,
    csResetAppsService,
    LicenseFactory
  ) {
    'ngInject'

    var _appId

    angular.extend($scope, {
      settings: {},
      license: {},
      rules: {},
      select: {
        importances: APP_IMPORTANCE_RANKING
      },
      isAssessLanguageSupported: isAssessLanguageSupported,
      requiredRoleToArchive: getRequiredRoleToArchive()
    })

    angular.extend($scope, {
      checkDisplayName: checkDisplayName
    })

    function init() {
      _appId = $routeParams.appId

      $scope.$on('updateAppDisplayNameFromHeader', function (event, data) {
        $scope.settings.displayName = data
      })

      $scope.appId = _appId

      getApplication()
    }

    function getRequiredRoleToArchive() {
      const restrictedEditRole =
        UserService.getCurrentOrganization().properties.restricted_edit_role
      return restrictedEditRole ? 'RULES_ADMIN' : 'EDIT'
    }

    function checkDisplayName() {
      if ($scope.settings.displayName.length == 0) {
        return
      }

      return ApplicationFactory.checkDisplayName(_appId, {
        displayName: $scope.settings.displayName
      })
        .then(function () {
          $scope.form.displayName.$setValidity('unique', true)
        })
        .catch(function (response) {
          if (response.status === 409) {
            $scope.form.displayName.$setValidity('unique', false)
          }
        })
    }

    $scope.save = function () {
      var data = {
        display_name: $scope.settings.displayName,
        code: $scope.settings.code,
        override_url: $scope.settings.url,
        importance: $scope.settings.importance,
        notes: $scope.settings.notes
      }

      return ApplicationFactory.updateAppSettings(_appId, data)
        .then(function (response) {
          logger.logSuccess(response.data.messages[0])
          $scope.$emit(
            'updateAppDisplayNameFromSettings',
            $scope.settings.displayName
          )
          $scope.form.$dirty = false
        })
        .catch(ErrorService.processError)
        .finally(function () {
          $uibModalInstance.close()
        })
    }

    function getApplication() {
      $scope.settings = ApplicationService.buildApplicationSettings(application)
      $scope.license = application.license
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }

    $scope.archive = function () {
      // Dismiss modal and have parent handle displaying react archive modal
      $uibModalInstance.close('archive')
    }

    $scope.reset = function () {
      $uibModalInstance.dismiss('cancel')
      csResetAppsService
        .resetOneApp(application)
        .catch(ErrorService.processError)
    }

    $scope.apply = function () {
      LicenseFactory.applyLicense(application.app_id)
        .then(function (response) {
          logger.logSuccess(response.data.messages[0])
        })
        .catch(ErrorService.processError)
        .finally(function () {
          $uibModalInstance.close()
        })
    }

    init()
  }
})()
